import { useLayoutStore } from "@/stores/layout.ts";

/**
 * Shows a snackbar for non-server errors (status < 500).
 * For server errors (status >= 500), does nothing (assume global handler will notify).
 */
export function handleLocalError(status: number, message: string) {
  const layoutStore = useLayoutStore();

  // Only show snackbar for non-server errors
  if (status >= 500) {
    return;
  }

  layoutStore.addSnackbarMessage(message, "error", "alert-filled");
}
